<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined color="primary" class="mr-3">
        <slot name="title"></slot>
      </v-btn>
    </template>
    <v-form
      lazy-validation
      @submit.prevent="onConfirm"
      v-model="valid"
      ref="form"
    >
      <v-card>
        <v-card-title class="modal-header elevation-10">
          <v-row>
            <v-col>
              <slot name="title"></slot>
            </v-col>
            <v-col class="text-right">
              <v-icon @click="onClose" color="white">mdi-window-close</v-icon>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>Dados do Município</v-col>
          </v-row>
          <!-- <v-row>
          <v-col style="display: flex; align-items: center">
            <v-checkbox
              v-model="dados.pacoteGovernoEstado"
              id="pacoteGovernoEstado"
              color="primary"
              label="Faz parte do pacote do governo do estado"
              hide-details="auto"
              style="max-width: fit-content; margin: 0; margin-right: 10px"
            />
            <v-tooltip bottom>
              <template v-slot:activator="tooltip">
                <div v-bind="tooltip.attrs" v-on="tooltip.on">
                  <v-icon color="primary">mdi-information</v-icon>
                </div>
              </template>
              Essa opção libera o combo 'Plus e Flex'
            </v-tooltip>
          </v-col>
        </v-row> -->

          <v-row>
            <v-col>
              <v-text-field
                v-model="dados.cnpj"
                label="CNPJ*"
                name="cnpj"
                type="text"
                v-mask="'##.###.###/####-##'"
                hide-details="auto"
                :rules="[obrigatorio]"
                placeholder="00.000.000/0000-00"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="dados.cep"
                label="Cep*"
                name="Cep"
                type="text"
                v-mask="'#####-###'"
                hide-details="auto"
                @blur="atualizarEndereco"
                :rules="[obrigatorio]"
                placeholder="00000-000"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="dados.endereco"
                label="Endereço*"
                name="endereco"
                type="text"
                :rules="[obrigatorio]"
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="dados.bairro"
                label="Bairro*"
                name="bairro"
                type="text"
                :rules="[obrigatorio]"
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="dados.cidade"
                label="Cidade*"
                name="cidade"
                type="text"
                :rules="[obrigatorio]"
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="dados.uf"
                label="UF*"
                name="uf"
                :rules="[obrigatorio]"
                type="text"
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="dados.numero"
                label="Numero*"
                name="numero"
                :rules="[obrigatorio]"
                type="text"
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>Dados do Representante Legal (Prefeito(a))</v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="dados.nomePrefeito"
                label="Nome*"
                name="nome"
                type="text"
                :rules="[obrigatorio]"
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="dados.nacionalidadePrefeito"
                label="Nacionalidade"
                name="nacionalidade"
                type="text"
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="dados.estadoCivilPrefeito"
                label="Estado Civil"
                name="estadoCivil"
                type="text"
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="dados.cpfPrefeito"
                label="CPF*"
                name="cpf"
                type="text"
                v-mask="'###.###.###-##'"
                hide-details="auto"
                :rules="[obrigatorio]"
                placeholder="000.000.000-00"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="dados.rgPrefeito"
                label="RG"
                name="rg"
                type="text"
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="dados.orgaoEmissorPrefeito"
                label="Orgão Emissor"
                name="orgaoEmissor"
                type="text"
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="dados.dataNascimentoPrefeito"
                label="Data de Nascimento"
                name="dataNascimento"
                type="text"
                hide-details="auto"
                v-mascara="'##/##/####'"
                placeholder="DD/MM/AAAA"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="dados.profissaoPrefeito"
                label="Profissão"
                name="profissao"
                type="text"
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="dados.emailPrefeito"
                label="Email*"
                name="email"
                type="text"
                hide-details="auto"
                :rules="[obrigatorio]"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="dados.telefonePrefeito"
                label="Telefone"
                name="telefone"
                type="text"
                v-mask="'(##) ####-####'"
                hide-details="auto"
                placeholder="(00) 0000-0000"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="dados.celularPrefeito"
                label="Celular"
                name="celular"
                type="text"
                v-mask="'(##) #####-####'"
                hide-details="auto"
                placeholder="(00) 00000-0000"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="dados.cepPrefeito"
                label="Cep"
                name="Cep"
                type="text"
                v-mask="'#####-###'"
                @blur="atualizarEnderecoPrefeito"
                hide-details="auto"
                placeholder="00000-000"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="dados.enderecoPrefeito"
                label="Endereço"
                name="endereco"
                type="text"
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="dados.numeroEnderecoPrefeito"
                label="Número"
                name="endereco"
                type="text"
                hide-details="auto"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="dados.bairroPrefeito"
                label="Bairro"
                name="bairro"
                type="text"
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="dados.cidadePrefeito"
                label="Cidade"
                name="cidade"
                type="text"
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <!-- <v-col cols="2">
              <v-text-field
                v-model="dados.ufPrefeito"
                label="UF"
                name="uf"
                type="text"
                hide-details="auto"
              ></v-text-field>
            </v-col> -->
          </v-row>
          <v-row>
            <v-col>Dados da Pessoa para Contato</v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="dados.pessoaContato"
                label="Nome"
                name="pessoaContato"
                type="text"
                hide-details="auto"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="dados.emailContato"
                label="Email*"
                name="emailContato"
                type="text"
                hide-details="auto"
                :rules="[obrigatorio]"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                v-model="dados.telefoneContato"
                label="Telefone"
                name="telefone"
                type="text"
                v-mask="'(##) ####-####'"
                hide-details="auto"
                placeholder="(00) 0000-0000"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                v-model="dados.celularContato"
                label="Celular"
                name="celular"
                type="text"
                v-mask="'(##) #####-####'"
                hide-details="auto"
                placeholder="(00) 00000-0000"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-textarea
                v-model="dados.requisitosPrefeituraPagMensal"
                label="Requisitos exigidos pela Prefeitura para o pagamento mensal"
                name="requisitosPrefeituraPagMensal"
                type="text"
                hide-details="auto"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="error" outlined text @click="onClose()">Fechar</v-btn>
          <v-btn color="info" outlined text type="submit">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { propostaApi, municipioPropostaDadosApi } from "@/apis/proposta";
import { correiosAPI } from "@/apis/correio";

export default {
  name: "ModalDadosCadastrais",
  props: {
    payload: { type: Object },
    dadosPayload: { type: Object },
  },
  data() {
    return {
      dialog: false,
      dados: { cep: "" },
      valid: true,
      obrigatorio: (v) => {
        if (!v) return "Campo Obrigatório";

        return true;
      },
    };
  },
  mounted() {},
  watch: {
    dadosPayload: {
      handler(val) {
        this.dados = val;
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(["setLoading"]),
    onClose() {
      this.dialog = false;
      this.$emit("onLoad");
    },
    async atualizarEndereco() {
      if (!this.dados.cep) {
        this.dados.endereco = null;
        this.dados.bairro = null;
        this.dados.cidade = null;
        this.dados.uf = null;
        this.$forceUpdate();
      }
      if (this.dados.cep.length == 9) {
        try {
          const { data } = await correiosAPI.cep(this.dados.cep);

          this.dados.endereco = data.logradouro;
          this.dados.bairro = data.bairro;
          this.dados.cidade = data.localidade;
          this.dados.uf = data.uf;
          this.$forceUpdate();
        } catch (error) {}
      }

      return;
    },
    async atualizarEnderecoPrefeito() {
      if (!this.dados.cepPrefeito) {
        this.dados.enderecoPrefeito = null;
        this.dados.bairroPrefeito = null;
        this.dados.cidadePrefeito = null;
        this.dados.ufPrefeito = null;
        this.$forceUpdate();
      }
      if (this.dados.cepPrefeito.length == 9) {
        try {
          const { data } = await correiosAPI.cep(this.dados.cepPrefeito);

          this.dados.enderecoPrefeito = data.logradouro;
          this.dados.bairroPrefeito = data.bairro;
          this.dados.cidadePrefeito = data.localidade;
          this.dados.ufPrefeito = data.uf;

          this.$forceUpdate();
        } catch (error) {}
      }

      return;
    },
    async onConfirm() {
      const validate = await this.$refs.form.validate();
      if (!validate) return;
      this.setLoading(true);
      const dados = { ...this.dados, municipioid: this.$route.params.id };
      if (dados.municipioPropostaDadosComplementaresId) {
        municipioPropostaDadosApi
          .update(dados)
          .then(() => {
            this.$notification.success("Dados cadastrais editado com sucesso!");
            this.$emit("onLoad");
            this.dialog = false;
            this.setLoading(false);
          })
          .catch((err) => {
            this.$notification.error("Erro ao editar os Dados cadastrais");
            console.log("Erro no editar ", err);
            this.setLoading(false);
          });
      } else {
        municipioPropostaDadosApi
          .add(dados)
          .then(() => {
            this.$notification.success("Dados cadastrais salvo com sucesso!");
            this.$emit("onLoad");
            this.dialog = false;
            this.setLoading(false);
          })
          .catch((err) => {
            this.$notification.error("Erro ao salvar os Dados cadastrais");
            console.log("Erro no salvar ", err);
            this.setLoading(false);
          });
      }
    },
  },
};
</script>
